

function Inicio() {
  return (
    <div>inicio</div>
  )
}

export default Inicio